import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js';
import { Subject } from 'rxjs';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-concurrencia',
  templateUrl: './concurrencia.component.html',
  styleUrls: ['./concurrencia.component.scss']
})
export class ConcurrenciaComponent implements OnInit {

    concurrencia: any[] = [];

    codins = [{ 'id': '989' , 'nombre': 'Bingo Gorrión'},
    { 'id': '461' , 'nombre': 'Bingo Canalejas'}];

    codin;
    // FlatpickrOptions
    fdesde: any = new Date().toISOString().slice(0, 10);
    fhasta: any = new Date().toISOString().slice(0, 10);
    // OPTIONS
    fdesdeoptions = { locale: Spanish,onClose: (selectedDates, dateStr, instance) => this.fdesde = dateStr,altFormat: 'Y-m-d' };
    fhastaoptions = { locale: Spanish,onClose: (selectedDates, dateStr, instance) => this.fhasta = dateStr,altFormat: 'Y-m-d' };

    optionsdt: DataTables.Settings = {};
    triggerdt: Subject<any> = new Subject();


  constructor(public rest: RestService, public user: UserService) { }

  ngOnInit() {
    this.optionsdt = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
    };
  }

  getAPI() {

    this.rest.getConcurrenciaAbonos(this.fdesde, this.fhasta, this.codin)
    .subscribe((data) => {
      this.concurrencia = data['data'];
    });
  }

  getKeys() {
    return (this.concurrencia && this.concurrencia.length > 0) ?  Object.keys(this.concurrencia[0]) : [];
  }

}
